module.exports = __webpack_public_path__ + "media/images/dividend/img-warrenbuffett-d6ef612b827d80bd4e797d804fc23804.png";